// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20bsg","rootMobile":"styles_rootMobile__3Cy7u"};